import { PressReleases } from 'src/db.js'
import { IssueLight } from './IssueEntity.js'
import { WarrantLight } from './WarrantEntity.js'
import { ConvertibleLight } from './ConvertibleEntity.js'
import { SelectType } from 'kysely'

export enum NewsType {
    NewsFlash,
    NewsArticle,
    PressRelease,
    CompanyFinancialCalendar,
    Report,
    MarketCommentary,
    EconomicCalendarToday,
    EconomicCalendarThisWeek,
    SystemsMessages,
}

export type PressReleaseListFilter = {
    companyId?: string
    minPublicationDate?: string
    maxPublicationDate?: string
    search?: string
    showOnlyReports?: boolean
    showOnlyWithRelatedTransactions?: boolean
}

type PressReleaseTranslation = {
    accuracyScore: number
    language: string
    prId: string
}

export type PressReleaseLight = Pick<
    SelectType<PressReleases>,
    'body' | 'companyId' | 'distributorName' | 'language' | 'publishedAt' | 'title' | 'id'
> & {
    newsType: NewsType | null
    relatedTransactions: Array<RelatedTransaction>
    translations: Array<PressReleaseTranslation>
}

type BaseRelatedTransaction = {
    id: string
    name: string | null
}

export type RelatedTransaction = BaseRelatedTransaction & (ConvertibleLight | IssueLight | WarrantLight)

export type PressReleaseEntity = PressReleaseLight & {
    attachments: Array<{ caption: string | null; mime: string | null; url: string }>
}
